import { render } from "./FormInput.vue?vue&type=template&id=3a3be680&scoped=true&ts=true"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=3a3be680&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3be680"]])

export default __exports__